import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from 'mobx-persist-store';
export default class VendorStore {
    constructor() {
        makeAutoObservable(this);
        makePersistable(this, { name: 'VendorStore', properties: ['vendors', 'selectedVendor', 'mappedVendors'] });
    }

    vendors = [];
    selectedVendor = {};
    mappedVendors = [];
    loading = false;
    mappedGroups = [];

    reset = () => {
        this.vendors = [];
        this.mappedVendors = [];
        this.selectedVendor = {};
    };

    setLoading = async isLoading => {
        runInAction(() => {
            this.loading = isLoading;
        });
    };

    setVendors = async (vendors) => {
        runInAction(async () => {
            this.vendors = vendors;
        });
    }
    setMapGroups = async (state) => {
        runInAction(async () => {
            this.mappedGroups = state;
        });
    }
    setMapVendors = async (state) => {
        runInAction(async () => {
            this.mappedVendors = state;
        });
    }

    setSelectedVendor = async (state) => {
        runInAction(async () => {
            this.selectedVendor = state;
        });
    }

}
